/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import VideoContent from './styles';

export interface IVideo {
  url: string;
}

const Video: React.FC<IVideo> = ({ url }) => {
  let urlEmbed = url;

  if (url.includes('watch?v=')) {
    urlEmbed = url ? url.replace('watch?v=', 'embed/') : '';
  }
  if (url.includes('https://youtu.be/')) {
    const pieces = url.split('/');
    const codeVideo = pieces[pieces.length - 1];
    urlEmbed = `https://www.youtube.com/embed/${codeVideo}`;
  }

  return (
    <VideoContent>
      <iframe
        title="video"
        src={urlEmbed}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </VideoContent>
  );
};

export default Video;
